/**
 * @file usePlatformShopOptions.ts
 * @description Магазины платформы для выбора в формах пользователей
 * (phase19.28 этап А): вместо зашитого списка «этапа 1» (`SHOPS_ETAP1`) и
 * догадки по ролям загруженных пользователей — `GET /admin/platform/shops`.
 * Один источник правды: новый магазин сразу доступен для назначения роли.
 * Список магазинов требует `PLATFORM_MANAGE_SHOPS` (ревью В3): без права не
 * грузим и ошибку не показываем — выбор магазина в формах просто скрыт.
 */

import { useMemo } from "react";

import { useHasPermission } from "../../auth/hooks";
import { SHOPS_PERMISSION, platformShops } from "../../lib/api-platform-shops";
import { usePlatformResource } from "./usePlatformResource";

export interface ShopOption {
  id: string;
  slug: string;
  displayName: string;
}

export function usePlatformShopOptions() {
  const allowed = useHasPermission(SHOPS_PERMISSION);
  const resource = usePlatformResource(
    allowed ? "shops?q=" : null,
    () => platformShops.list(),
    "Не удалось загрузить магазины — роль в магазине пока назначить нельзя",
  );
  const shops = useMemo<ShopOption[]>(
    () => (resource.data ?? []).map(({ id, slug, displayName }) => ({ id, slug, displayName })),
    [resource.data],
  );
  return { shops, loading: resource.loading, error: resource.error, reload: resource.reload };
}
